<template>
    <div class="loginBox">
        <div class="bannerBox">
            <div class="titleBox">
                <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
                <p>生物医疗销售全流程管理系统</p>
            </div>
            <div class="login">
                <div class="right">
                    <div class="title">信息修改</div>
                    <div class="logins">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input user" v-if="!isShow">
                            <el-form-item label="手机号/邮箱" prop="phone" class="box">
                                <el-input class="phone" v-model="ruleForm.phone" autocomplete="off" clearable
                                          placeholder="请输入有效的手机号/邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码" prop="code" class="box">
                                <div style="display: flex;">
                                    <el-input class="password" v-model="ruleForm.code" clearable
                                              placeholder="验证码" style="width: 80%"></el-input>
                                    <el-button type="primary" @click="submitUpload" :disabled="!this.canClick"
                                               style="width:170px;">{{content}}
                                    </el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="设置密码" prop="password" class="box">
                                <el-input class="phone" type="password" v-model="ruleForm.password" autocomplete="off"
                                          clearable
                                          placeholder="设置密码"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码" prop="checkPassword" class="box">
                                <el-input class="phone" type="password" v-model="ruleForm.checkPassword"
                                          autocomplete="off"
                                          clearable
                                          placeholder="确认密码"></el-input>
                            </el-form-item>
                        </el-form>
                        <div style="display: flex;justify-content: center;align-items: center;margin-top: 0.6rem">
                            <el-button style="width: 1rem" @click="back" v-if="!isShow">返回</el-button>
                            <el-button type="primary" style="width: 1rem" @click="comment('ruleForm')" v-if="!isShow">
                                提交
                            </el-button>
                        </div>
                        <div class="titles" style="margin-top:0" v-if="isShow">上传附件</div>
                        <div class="h-pieceCon2 ljjregmima" v-if="isShow" style="margin-top: 0.35rem">
                            <div class="h-formLine">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                         ref="formLabelAlign1"
                                         :inline="true" :rules="rules"
                                         class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="请上传二类经营许可证" class="h-elformWrap-1"
                                                  :prop="this.isGoverment == true? '': 'upload5' "
                                                  v-if="have2">
                                        <div style="display: flex;">
                                            <brupload

                                                    :refid="refid"
                                                    :reftype=this.reftypeAgent5
                                                    uploadflag
                                                    delflag
                                                    :showtime="false"
                                            >
                                            </brupload>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="请上传三类经营许可证"
                                                  class="h-elformWrap-1"
                                                  v-if="have3">
                                        <div style="display: flex;">
                                            <brupload

                                                    :refid="refid"
                                                    :reftype=this.reftypeAgent6
                                                    uploadflag
                                                    delflag
                                                    :showtime="false"
                                            >
                                            </brupload>
                                        </div>

                                    </el-form-item>
                                    <el-form-item label="请上传企业营业执照" class="h-elformWrap-2" prop="upload1">
                                        <brupload

                                                :refid="refid"
                                                :reftype=this.reftypeAgent1
                                                uploadflag
                                                delflag
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <el-form-item label="请上传银行开户证明" class="h-elformWrap-2" prop="upload2">
                                        <brupload

                                                :refid="refid"
                                                :reftype=this.reftypeAgent2
                                                uploadflag
                                                delflag
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <br>
                                    <el-form-item label="请上传法人身份证" class="h-elformWrap-2" prop="upload3">
                                        <brupload

                                                :refid="refid"
                                                :reftype=this.reftypeAgent3
                                                uploadflag
                                                delflag
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                    <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload4">
                                        <brupload

                                                :refid="refid"
                                                :reftype=this.reftypeAgent4
                                                uploadflag
                                                delflag
                                                :showtime="false"
                                        >
                                        </brupload>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
        <div class="bottoms">
            Copyright Haier 2019. All rights reserved
        </div>
    </div>
</template>

<script>
    import FirstLoginConfigService from "../api/FirstLoginConfigService";

    function checkPassword(pwd) {
        var len = pwd.length;
        var flag = true;
        for (var i = 1; i < len-3; i++) {
            var firstIndex = pwd.charCodeAt(i-1);
            var secondIndex = pwd.charCodeAt(i);
            var thirdIndex = pwd.charCodeAt(i+1);
            var fourthIndex = pwd.charCodeAt(i+2);

            if((fourthIndex - thirdIndex == 1)&&(thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
                flag =  false;
            }
        }
        return flag;

    }

    function validateKey(str) {
        //定义横向穷举
        var keyCode = [
            ["`~·", "1=", "2@@", "3#", "4$￥", "5%", "6^……", "7&", "8*", "9(（", "0）)", "-_", "=+"],
            [" ","qQ", "wW", "eE", "rR", "tT", "yY", "uU", "iI", "oO", "pP", "[{【", "]}】", "\\|、"],
            [" ","aA", "sS", "dD", "fF", "gG", "hH", "jJ", "kK", "lL", ";:", "\'\"’“"],
            [" ","zZ", "xX", "cC", "vV", "bB", "nN", "mM", ",《<", ".>》", "/?？"]
        ];

        //找出给出的字符串，每个字符，在坐标系中的位置。
        var c = str.split("");
        var x = new Array();
        var y = new Array();
        for (var i = 0; i < c.length; i++) {
            var temp = c[i];
            toHere:
                for (var j = 0; j < keyCode.length; j++) {
                    for (var k = 0; k < keyCode[j].length; k++) {
                        var jk = keyCode[j][k];
                        if (jk.indexOf(temp)!=-1) {
                            x.push(j);
                            y.push(k);
                            break toHere;
                        }
                    }
                }
        }
        var flag = false;
        for (var i = 0; i < x.length - 2; i++) {
            // 如果X一致，那么就是在一排
            if (x[i] == x[i + 1] && x[i + 1] == x[i + 2]) {//四者在同一行上
                if (y[i] > y[i + 2]) {
                    if (y[i] - 1 == y[i + 1] && y[i] - 2 == y[i + 2]) {
                        flag = true;
                        break;
                    }
                } else {
                    if (y[i] + 1 == y[i + 1] && y[i] + 2 == y[i + 2]) {
                        flag = true;
                        break;
                    }
                }
            } else if (x[i] != x[i + 1]
                && x[i + 1] != x[i + 2]
                && x[i] != x[i + 2]
            ) {//四者均不在同一行上,但是如果y相同，说明是一列
                if (y[i] == y[i + 1] && y[i + 1] == y[i + 2]) {
                    flag = true;
                    break;
                }
            }
        }
        return flag;
    }

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    var reg1 = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z_\W]{10,}$))/;
                    var reg2 = /([a-zA-Z0-9])\1{3}/;
                    var reg3 = /(iHaier|portal)/;
                    if (!reg1.test(value)) {
                        callback(new Error("密码必须是10位以上,必须含有大写字母、小写字母、数字、特殊符号中的三项"));
                    } else if (reg2.test(value)) {
                        callback(new Error("不能包含超过3位的重复数字或字母"));
                    } else if (!checkPassword(value)) {
                        callback(new Error("不能包含超过3位的连续数字或字母"));
                    } else if (validateKey(value)){
                        callback(new Error("不能包含键盘连续的字母,符号和数字"));
                    } else if (reg3.test(value)){
                        callback(new Error("不能包含应用名称"));
                    } else {
                        callback();
                    }
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                isShow: false,
                content: '发送验证码',
                totalTime: 60,
                canClick: true,
                refid: '',
                reftypeAgent1: '代理商注册-企业营业执照',
                reftypeAgent2: '代理商注册-银行开户证明',
                reftypeAgent3: '代理商注册-法人身份证',
                reftypeAgent4: '代理商注册-一般纳税人提供相关资质证明',
                reftypeAgent5: '代理商注册-二类经营许可证',
                reftypeAgent6: '代理商注册-三类经营许可证',
                user: '',
                ruleForm: {
                    phone: '',
                    code: '',
                    password: '',
                    checkPassword: '',
                },
                rules: {
                    phone:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    code:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                    password:
                        [
                            {required: true, validator: validatePass, trigger: 'blur'},
                        ],
                    checkPassword:
                        [
                            {required: true, validator: validatePass2, trigger: 'blur'},
                        ],
                },
                formLabelAlign1: '',
                isGoverment: '',
                have2: true,
                have3: false,
                have6858: false,
                have6840: false,
                have6854: false,
            }
        },
        created() {
            console.log(this.$route.query);
            this.user = this.$route.query.user;
            this.refid = this.$route.query.user;
        },
        methods: {
            // 提交按钮功能
            comment(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        console.log(valid,'aaaaaaaaaaaaaaaaaaaaa')
                        // this.$router.push("/personal/userin?usercode="+this.$route.query.user);
                        FirstLoginConfigService.comment(this.user, this.ruleForm.phone, this.ruleForm.code, this.ruleForm.password)
                            .then(res => {
                                if (res.f) {
                                    this.$router.push("/login");
                                    this.$message({
                                        type: 'success',
                                        message: '请登录！'
                                    });
                                    // this.isShow = true;
                                    // if (res.obj.permit == '3' || res.obj.permit == '5') {
                                    //     this.have3 = true;
                                    // }
                                }
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 返回按钮功能
            back() {
                this.$router.push("/login");
            },
            submitUpload() {
                if (this.ruleForm.phone == '') {
                    this.$message({
                        type: 'warning',
                        message: '请先填写手机号/邮箱！'
                    });
                    return;
                }else {
                    this.getCode();
                }
                if (!this.canClick) return
                this.canClick = false;
                this.content = this.totalTime + "s秒后重新发送"
                let clock = window.setInterval(() => {
                    this.totalTime--
                    this.content = this.totalTime + 's后重新发送'
                    if (this.totalTime < 0) {
                        window.clearInterval(clock)
                        this.content = '重新发送验证码'
                        this.totalTime = 30
                        this.canClick = true  //这里重新开启
                    }
                }, 1000)
            },
            getCode() {
                FirstLoginConfigService.getCode(this.user, this.ruleForm.phone).then(res => {

                })
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .box {
        display: flex;
    }

    .loginBox {
        width: 100%;
        height: 100%;
        background: url(../assets/images/login-bg.jpg)
    }

    .bannerBox {
        width: 1100px;
        margin: 0 auto;
    }

    .titleBox {
        padding-top: 30px;
        display: flex;
    }

    .titleBox p {
        font-size: 30px;
        color: #ffffff;
        padding: 0;
        margin: 0;
        line-height: 50px;
        margin-left: 38px;
    }

    .login {
        width: 100%;
        display: flex;
        margin-top: 28px;
        margin-bottom: 0.5rem;
    }

    .login .right {
        width: 100%;
        height: 100%;
        padding: 0 0 1rem 0;
        background: #fff;
        position: relative;
        border-radius: 0 8px 8px 0px;
    }


    .login .right .title {
        margin-top: 1rem;
        text-align: center;
        font-size: 24px;
        color: #128bf1;
    }

    .logins {
        width: 80%;
        display: flex;
        flex-direction: column;
        text-align: left;
        margin: 0 auto;
        margin-top: 1rem;
    }

    .bottoms {
        background: #000;
        width: 100%;
        height: 53px;
        text-align: center;
        line-height: 53px;
        font-size: 14px;
        color: #a4a4a4;
    }

</style>
<style>
    .box .el-form-item__label {
        width: 10%;
    }

    .box .el-form-item__content {
        width: 90%;
    }

    .ljjregmima .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 37%;
    }

    .ljjregmima .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 63%;
    }

    .ljjregmima .h-formbLine .h-elformWrap-2 .el-form-item__label {
        width: 84%;
    }

    .ljjregmima .h-formbLine .h-elformWrap-2 .el-form-item__content {
        width: 16%;
    }
</style>